import type { ServerPaginationConfig } from '@shared/types/module-config';

export const PLATFORM_TRANSFERS_PAGINATION: ServerPaginationConfig = {
  enabled: true,
  mode: 'server',
  pageParam: 'page',
  sizeParam: 'pageSize',
  defaultSize: 25,
  firstPage: 0,
  sendPageIfDefault: true,
};

export const PLATFORM_TRANSFERS_ROUTE_PATHS = {
  platformTransfers: '/movements/platform-transfers',
};

export const PLATFORM_TRANSFERS_API_PATHS = {
  cashoutsList: '/v1/api/platform/partners/cashout',
  depositsList: '/v1/api/platform/partners/deposit',
  cashoutNotify: '/v1/api/platform/partners/cashout/notify',
  depositNotify: '/v1/api/platform/partners/deposit/notify',
};

export const CASHOUT_URL_FILTER_KEYS = [
  'externalCashoutId',
  'status',
  'internalReferenceId',
  'partnerId',
  'partnerCashoutId',
  'dateStart',
  'dateEnd',
  'endToEndId',
  'page',
  'pageSize',
];

export const DEPOSIT_URL_FILTER_KEYS = [
  'externalDepositId',
  'status',
  'partnerId',
  'partnerDepositId',
  'dateStart',
  'dateEnd',
  'endToEndId',
  'page',
  'pageSize',
];
